import React, { useContext, useState } from "react";
import PsContext from "../../context";
import Header from "../header";
import CircularList from "./circularList";

const Circular = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);

  return (
    <>
      <Header backAction={true} title="Circular" />

      <div className="page-content-wrapper">
        <div className="container py-3">
          <section className="top-space pt-0 pb-0">
            <CircularList titleText={"Circular"} />
          </section>
          <section className="top-space "></section>
        </div>
      </div>
    </>
  );
};
export default Circular;
